import styled, { css, keyframes } from 'styled-components';

type Props = {
  height?: number | string;
  width?: number | string;
  marginTop?: string;
  marginLeft?: string;
  marginBottom?: string;
  marginRight?: string;
  rounded?: boolean;
}

export const pulseKeyframe = keyframes`
    0% {
      background-position: 0% 0%;
    }
    100% {
      background-position: -135% 0%;
    }
`

export const Wrapper = styled.div<Props>`
  display: inline-block;
  background: linear-gradient(-90deg, var(--black-300) 0%, var(--black-100) 50%, var(--black-400) 100%);
  background-size: 400% 400%;
  
  animation: ${pulseKeyframe} 1.2s ease-in-out infinite;

  ${(props) => css`
    width: ${typeof props.width === "number" ? `${props.width}%` : typeof props.width === "string" ? props.width : "100%"};
    height: ${typeof props.height === "number" ? `${props.height}%` : typeof props.height === "string" ? props.height : "100%"};
  `}

  border-radius: 5px;

  &::before {
    content: "\00a0";
  }

  ${(props) => props.rounded === true && css`
    border-radius: 100px;
  `}
`;